export const ERC20Addr = '0xeB8eec5a2dBf6e6f4Cc542ad31CCe706f8f80419';
export const ClientHandlerAddr = '0xCcf7b7F747100f3393a75DDf6864589f76F4eA25';